import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'db-vaccinations',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'db-vaccinations-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {                           
                        transKey: 'breadcrumbs.db-vaccination-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "db-vaccination-index" */ '@/modules/configurations/database-load/db-vaccinations/views/Index.vue')
        }
    ]
}